import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'does_the_fac_follow_any_of_the_following_practices_concerning_p'

export const dataPointDefinition = {
  retracedId: 'does_the_fac_follow_any_of_the_following_practices_concerning_p',
  name: 'Does the facility follow any of the following practices concerning prison labor?',
  description: '',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'PRISON_LABORERS_HAVE_NOT_FREELY_AND_FORMALLY_CONSENTED_TO_PERFO',
      text: 'Prison laborers have not freely and formally consented to perform the work',
      externalIds: [
        {
          id: 'rh-for-3',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'THE_FACILITY_DOES_NOT_TREAT_PRISON_LABORERS_AND_NON_PRISON_WORK',
      text: 'The facility does not treat prison laborers and non-prison workers similarly (conditions of work such as wages, hours of work, health and safety, etc.)',
      externalIds: [
        {
          id: 'rh-for-4',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'THERE_IS_NO_SUPERVISION_AND_CONTROL_BY_A_PUBLIC_AUTHORITY',
      text: 'There is no supervision and control by a public authority',
      externalIds: [
        {
          id: 'rh-for-5',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'NONE_OF_THE_ABOVE',
      text: 'None of the above',
      externalIds: [
        {
          id: 'rh-for-6',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: [
                'PRISON_LABORERS_HAVE_NOT_FREELY_AND_FORMALLY_CONSENTED_TO_PERFO',
                'THE_FACILITY_DOES_NOT_TREAT_PRISON_LABORERS_AND_NON_PRISON_WORK',
                'THERE_IS_NO_SUPERVISION_AND_CONTROL_BY_A_PUBLIC_AUTHORITY',
                'NONE_OF_THE_ABOVE',
              ],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'rh-for-2',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 5050,
  sectionId: '2.2.7',
  impactArea: 'Forced Labour',
  impactAreaId: 'FORCED_LABOUR',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
